// src/components/common/MinutesPickerField.js
// 78차: 테마 준비시간에 마이너스(-N분)를 허용해달라는 요청 — 여러 방(room)을 동시에
// 운영해 실제 예약 간격(주기)이 플레이시간보다 짧은 매장(진행 90분인데 60분 주기로
// 손님을 받는 경우 등)을 표현할 방법이 지금까지 없었음. StoreAdminScreen.js의
// ScrollPicker(수동입력 탭에서 이미 검증된 스크롤 휠 패턴)를 그대로 본떠, 모달 안에
// -60~+60분을 스크롤로 고르는 공용 필드로 분리 — 매장관리자/총관리자 양쪽의
// "매장 등록"/"매장 수정" 화면에서 재사용.
import React, { useState, useRef, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Modal, ScrollView } from 'react-native';
import { COLORS } from '../../constants/theme';
import AppHeader from './AppHeader';
import GradientButton from './GradientButton';

const ITEM_H = 44;
const formatMinutes = (m) => (m === 0 ? '0분' : m > 0 ? `+${m}분` : `${m}분`);

export default function MinutesPickerField({ label, value, onChange, min = -60, max = 60 }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(Number(value) || 0);
  const scrollRef = useRef(null);
  const items = [];
  for (let m = min; m <= max; m++) items.push(m);
  const draftIdx = items.indexOf(draft);

  useEffect(() => {
    if (open) {
      setDraft(Number(value) || 0);
    }
  }, [open, value]);

  useEffect(() => {
    if (open && scrollRef.current && draftIdx >= 0) {
      setTimeout(() => {
        try { scrollRef.current?.scrollTo({ y: draftIdx * ITEM_H, animated: false }); } catch (_) {}
      }, 50);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <View style={{ flex: 1 }}>
      {label ? <Text style={f.label}>{label}</Text> : null}
      <TouchableOpacity style={f.trigger} onPress={() => setOpen(true)}>
        <Text style={f.triggerText}>{formatMinutes(Number(value) || 0)}</Text>
      </TouchableOpacity>

      <Modal visible={open} transparent animationType="slide" onRequestClose={() => setOpen(false)}>
        <View style={f.overlay}>
          <View style={f.sheet}>
            <AppHeader isModal centerElement={<Text style={f.sheetTitle}>{label || '분 선택'}</Text>} />
            <View style={f.pickerBox}>
              <View style={f.highlightBar} pointerEvents="none" />
              <ScrollView
                ref={scrollRef}
                showsVerticalScrollIndicator={false}
                snapToInterval={ITEM_H}
                decelerationRate="fast"
                contentContainerStyle={{ paddingVertical: ITEM_H * 2 }}
                onMomentumScrollEnd={(e) => {
                  const idx = Math.round(e.nativeEvent.contentOffset.y / ITEM_H);
                  const clamped = Math.max(0, Math.min(idx, items.length - 1));
                  if (items[clamped] != null) setDraft(items[clamped]);
                }}
              >
                {items.map((m) => (
                  <TouchableOpacity key={m} style={[f.item, { height: ITEM_H }]} onPress={() => setDraft(m)} activeOpacity={0.7}>
                    <Text style={[f.itemText, draft === m && f.itemTextOn]}>{formatMinutes(m)}</Text>
                  </TouchableOpacity>
                ))}
              </ScrollView>
            </View>
            <View style={{ padding: 16 }}>
              <GradientButton label="선택 완료" onPress={() => { onChange(draft); setOpen(false); }} />
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
}

const f = StyleSheet.create({
  label:        { color: COLORS.textMuted, fontSize: 11, marginBottom: 6 },
  trigger:      { backgroundColor: COLORS.surface2, borderWidth: 1, borderColor: COLORS.border, borderRadius: 8, paddingHorizontal: 12, height: 42, justifyContent: 'center' },
  triggerText:  { color: COLORS.text, fontSize: 14, fontWeight: '700' },
  overlay:      { flex: 1, backgroundColor: 'rgba(0,0,0,0.75)', justifyContent: 'flex-end' },
  sheet:        { backgroundColor: COLORS.surface, borderTopLeftRadius: 16, borderTopRightRadius: 16, overflow: 'hidden' },
  sheetTitle:   { color: COLORS.text, fontSize: 15, fontWeight: '800' },
  pickerBox:    { height: 220, backgroundColor: COLORS.surface2, marginHorizontal: 16, marginTop: 16, borderRadius: 10, borderWidth: 1, borderColor: COLORS.border, overflow: 'hidden', position: 'relative' },
  highlightBar: { position: 'absolute', top: '50%', left: 0, right: 0, height: ITEM_H, marginTop: -ITEM_H / 2, backgroundColor: COLORS.gold + '15', borderTopWidth: 1, borderBottomWidth: 1, borderColor: COLORS.gold + '40', zIndex: 1 },
  item:         { justifyContent: 'center', alignItems: 'center' },
  itemText:     { color: COLORS.textMuted, fontSize: 14 },
  itemTextOn:   { color: COLORS.gold, fontWeight: '800', fontSize: 15 },
});
